// Library imports
import React from "react";
import styled from "styled-components";

// Local imports
import KeywordExplorer from "./KeywordExplorer";
import PeopleAndList from "./PeopleAndList";

type Props = {
  isToggle?: boolean;
  isText?: boolean;
  onClickAudienceDone?: any;
  handleAddPeople?: any;
  selectedContactIds?: number[];
  selectedListIds?: number[];
  hideRecommendedList?: boolean;
  isPersonAdded?: any;
  enableScrollForContacts?: boolean;
  subtractWidth?: string;
  disableMaxHeight?: boolean;
  campaignKeywords?: string[];
  setCampaignKeywords?: any;
  inCreateCampaign?: boolean;
  inPublish?: boolean;
  inCreateNewList?: boolean;
  selectAllFlag?: boolean;
  unselectedContactIdsState?: string[];
};
const CampaignkeywordAsider: React.FC<Props> = ({
  isToggle,
  isText,
  onClickAudienceDone,
  handleAddPeople,
  selectedContactIds,
  selectedListIds,
  hideRecommendedList,
  isPersonAdded,
  enableScrollForContacts,
  subtractWidth,
  disableMaxHeight,
  campaignKeywords,
  setCampaignKeywords,
  inCreateCampaign,
  inPublish,
  inCreateNewList,
  selectAllFlag,
  unselectedContactIdsState,
}) => {
  return (
    <Wrapper
      className={`wrapper-campaign-keyword ${isToggle ? "open" : ""}`}
      subtractWidth={subtractWidth ? subtractWidth : "1230px"}
    >
      {isText === true ? (
        <KeywordExplorer
          handleOnClickDone={onClickAudienceDone}
          keywords={campaignKeywords}
          setCampaignKeywords={setCampaignKeywords}
        />
      ) : (
        <PeopleAndList
          inCreateNewList={inCreateNewList}
          inPublish={inPublish}
          inCreateCampaign={inCreateCampaign}
          onClickAudienceDone={onClickAudienceDone}
          handleAddPeople={handleAddPeople}
          selectedContactIds={selectedContactIds}
          selectedListIds={selectedListIds}
          hideRecommendedList={hideRecommendedList}
          isPersonAdded={isPersonAdded}
          enableScrollForContacts={enableScrollForContacts}
          disableMaxHeight={disableMaxHeight}
          selectAllFlag={selectAllFlag}
          unselectedContactIdsState={unselectedContactIdsState}
          isOpened={isToggle}
        />
      )}
    </Wrapper>
  );
};

export default React.memo(CampaignkeywordAsider);
interface IWrapperProps {
  subtractWidth?: string;
}

const Wrapper = styled("div")<IWrapperProps>`
  transition: 0.5s;
  box-sizing: border-box;
  height: 100vh;
  overflow-y: auto;
  width: 0px;
  background-color: #f7f7f7;
  position: relative;
  opacity: 0;
  display: none;
  right: -5000px;
  width: ${(props) => `calc(100vw - ${props.subtractWidth})`};
  width: calc(100vw - 640px);
  padding: 62px 55px 29px 55px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding: 50px 40px 30px 40px;
    width: calc(100vw - 515px);
  }
  &.open {
    transition: 0.5s;
    overflow: hidden;
    right: 0;
    display: block;
    opacity: 1;
  }
`;
